<section class="h-[100vh] h-[100dvh] mt-8 px-4 mb-96 sm:mb-24 sm:px-12 md:px-16 lg:px-20 dark:text-white">
  <div>
    <form [formGroup]="emailSettingsFrom"
    (ngSubmit)="onEmailSettingsFormSubmit()">
    <div class="flex flex-col w-full justify-center items-center">
      @if(showSuccesfullyUpdatedSettings){
        <div class="flex items-center p-4 mb-4 text-sm text-green-700 border border-green-300 rounded-lg bg-red-50 dark:bg-gray-800 dark:text-green-400 dark:border-green-800" role="alert">
          <img
            src="assets/icons/info-green.svg"
            class="flex-shrink-0 inline w-4 h-4 me-3"
            aria-hidden="true"
            alt="Almanjobs logo"
          />
          <div>
            Your email settings have been successfully saved
          </div>
        </div>
      }
      @if(showEmailForm){
        <div class="flex flex-col w-full justify-center max-w-md">
          @if(showCouldNotFindEmailMessage){
            <div
            class="flex items-center p-4 mb-4 text-sm text-red-800 border border-red-300 rounded-lg bg-red-50 dark:bg-gray-800 dark:text-red-400 dark:border-red-800"
            role="alert"
          >
            <img
              src="assets/icons/info-red.svg"
              class="flex-shrink-0 inline w-4 h-4 me-3"
              aria-hidden="true"
              alt="Almanjobs logo"
            />
            <div> we could not find your email, please enter your email below</div>
          </div>
          }
          <div class="flex flex-col justify-center">
            <label for="input-group-1" class="block mb-2 text-sm font-medium dark:text-white">Your Email</label>
            <div class="relative mb-6">
              <div class="absolute inset-y-0 start-0 flex items-center ps-3.5 pointer-events-none">
                <ng-icon name="bootstrapEnvelopeFill" class="text-gray-400"></ng-icon>
              </div>
              <input formControlName="email"
                     type="text"
                     id="input-group-1"
                     class="bg-gray-50 border border-gray-300 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full ps-10 p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
            </div>
          </div>
        </div>
      }
    </div>
    <!-- Email Notifications -->
    <div [dir]="languageDirection"
    class="p-4 mb-4 bg-white border border-gray-200 rounded-xl shadow-sm dark:border-gray-700 sm:p-8 dark:bg-gray-800">

        <div class="flow-root">
          <div class="flex flex-row justify-between">
            <div class="flex flex-col">
              <h3 class="text-xl font-semibold dark:text-white">{{"UNSUBSCRIBE.EMAIL-NOTIFICATIONS.TITLE" | translate}}</h3>
            </div>
            <div class="flex flex-col justify-center">
              <label
                for="allEmails"
                class="relative flex items-center cursor-pointer"
              >
                <input type="checkbox" id="allEmails" class="sr-only" (click)="selectOrDeselectAll()" [checked]="allEmailsAreSelected"/>
                <span
                  class="h-6 bg-gray-200 border border-gray-200 rounded-full w-11 toggle-bg dark:bg-gray-700 dark:border-gray-600"
                ></span>
              </label>
            </div>
          </div>
          <div class="divide-y divide-gray-200 dark:divide-gray-700">
            <div class="flex items-center justify-between gap-4 py-4">
              <div class="flex flex-col flex-grow">
                <div class="text-lg font-semibold dark:text-white">
                  {{"UNSUBSCRIBE.EMAIL-NOTIFICATIONS.NOTIFICATIONS-EMAIL" | translate}}
                </div>
                <div class="text-base font-normal text-gray-500 dark:text-gray-400">
                  {{"UNSUBSCRIBE.EMAIL-NOTIFICATIONS.NOTIFICATIONS-EMAIL-DESCRIPTION" | translate}}
                </div>
              </div>
              <label
                for="activityEmails"
                class="relative flex items-center cursor-pointer"
              >
                <input  formControlName="activityEmails"
                        type="checkbox"
                        id="activityEmails"
                        class="sr-only"/>
                <span
                  class="h-6 bg-gray-200 border border-gray-200 rounded-full w-11 toggle-bg dark:bg-gray-700 dark:border-gray-600"
                ></span>
              </label>
            </div>


            <div class="flex items-center justify-between gap-4 py-4">
              <div class="flex flex-col flex-grow">
                <div class="text-lg font-semibold text-gray-900 dark:text-white">
                  {{"UNSUBSCRIBE.EMAIL-NOTIFICATIONS.MEETINGS-EMAIL" | translate}}
                </div>
                <div class="text-base font-normal text-gray-500 dark:text-gray-400">
                  {{"UNSUBSCRIBE.EMAIL-NOTIFICATIONS.MEETINGS-EMAIL-DESCRIPTION" | translate}}
                </div>
              </div>
              <label
                for="meetingEmails"
                class="relative flex items-center cursor-pointer"
              >
                <input  formControlName="meetingEmails"
                        type="checkbox"
                        id="meetingEmails"
                        class="sr-only"/>
                <span
                  class="h-6 bg-gray-200 border border-gray-200 rounded-full w-11 toggle-bg dark:bg-gray-700 dark:border-gray-600"
                ></span>
              </label>
            </div>

            <div class="flex items-center justify-between gap-4 py-4">
              <div class="flex flex-col flex-grow">
                <div class="text-lg font-semibold dark:text-white">
                  {{"UNSUBSCRIBE.EMAIL-NOTIFICATIONS.NEWSLETTER" | translate}}
                </div>
                <div class="text-base font-normal text-gray-500 dark:text-gray-400">
                  {{"UNSUBSCRIBE.EMAIL-NOTIFICATIONS.NEWSLETTER-DESCRIPTION" | translate}}
                </div>
              </div>
              <label
                for="newsletterEmails"
                class="relative flex items-center cursor-pointer"
              >
              <input  formControlName="newsletterEmails"
                      type="checkbox"
                      id="newsletterEmails"
                      class="sr-only"/>
                <span
                  class="h-6 bg-gray-200 border border-gray-200 rounded-full w-11 toggle-bg dark:bg-gray-700 dark:border-gray-600"
                ></span>
              </label>
            </div>
          </div>
          <div class="flex justify-end rtl:justify-start mt-6">
            <button
              class="text-white bg-primary-700 hover:bg-primary-800 focus:ring-4 focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800"
            >
            {{"UNSUBSCRIBE.EMAIL-NOTIFICATIONS.SAVE" | translate}}
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</section>
